import { render, staticRenderFns } from "./manuals.vue?vue&type=template&id=40f38631&"
import script from "./manuals.vue?vue&type=script&lang=ts&"
export * from "./manuals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports